var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new"},[_c('van-nav-bar',{attrs:{"title":"明细","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_vm._v(" "),_vm._l((_vm.images),function(item,index){return _c('div',{key:index,staticClass:"imgArr"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item}})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36df296f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/infoNew.vue
// module id = null
// module chunks = 